import { LuFlower2 } from 'react-icons/lu'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { conditions } from '@/data/womensHealth'

export const WomensHealthConditions = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader
        title="Every stage of a"
        accent="woman's life"
        description="Natural, plant-based approaches for the full spectrum of women's health."
      />
      <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {conditions.map((c, index) => (
          <li key={c.title}>
            <Reveal delay={(index % 4) * 80} className="h-full">
              <div className="group h-full rounded-3xl border border-base-200 bg-white p-6 transition-colors hover:border-green-300">
                <span className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-green-50 text-green-700">
                  <LuFlower2 aria-hidden="true" className="h-5 w-5" />
                </span>
                <h3 className="mb-2 font-display text-xl leading-tight text-base-900 transition-colors group-hover:text-green-800">
                  {c.title}
                </h3>
                <p className="text-sm leading-6 text-base-600">{c.desc}</p>
              </div>
            </Reveal>
          </li>
        ))}
      </ul>
    </div>
  </section>
)
